export const normalizePath = (path: string): string => {
  if (path === '/') {
    return '/';
  }
  const trimmed = path.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
};
